export const POST_FORM_TITLE = 'post-form.title';
export const POST_FORM_TITLE_PLACEHOLDER = 'post-form.title-placeholder';
export const POST_FORM_BODY_PLACEHOLDER = 'post-form.body-placeholder';
export const POST_FORM_SUBMIT_BUTTON_LABEL = 'post-form.submit-button-label';
export const POST_FORM_REQUIRED_ERROR_MESSAGE = 'post-form.required-error-message';
export const POST_FORM_TITLE_MAX_LENGTH_ERROR_MESSAGE = 'post-form.title-max-length-error-message';
export const POST_FORM_HASHTAGS_TITLE = 'post-form.hashtags-title';
